import type { FC } from 'react';
import { useState } from 'react';
import { Tabs, Tab, Typography, Container } from '@material-ui/core';
import Funnel from './Funnel';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const GestionSubgerenteJdn: FC<any> = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const onChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Container sx={{ p: 0 }}>
            <Typography component="span">{children}</Typography>
          </Container>
        )}
      </div>
    );
  };

  return (
    <>
      <Tabs value={tabIndex} onChange={onChangeTab}>
        <Tab label="Funnel E2E" />
      </Tabs>
      <TabPanel index={0} value={tabIndex}>
        <Funnel />
      </TabPanel>
    </>
  );
};

export default GestionSubgerenteJdn;
